export const ServiceConsignments1 = [
    {
        name: 'Sameday',
        value: 4
    },
    {
        name: 'Overnight',
        value: 3
    },
    {
        name: 'International',
        value: 2
    }
];

export const ServiceConsignments2 = [
    {
        name: 'Collect/Carriage forward',
        value: 1
    },
    {
        name: 'Third party',
        value: 0
    }
];